import { JobType } from 'types';

import { ImagePreset } from '@dnse/ui';

import { JobCard } from '../common/Job/JobCard';
import { JobCardLargeSize } from '../common/Job/JobCardLargeSize';



interface Props {
  recommendJobs: JobType[];
  handleClearFilter: () => void;
}

export const NotFoundJobs: React.FC<Props> = ({
  recommendJobs,
  handleClearFilter
}) => {
  return (
    <div className="flex flex-col items-center  md:min-w-[823px] pt-[50px] lg:pt-0">
      <ImagePreset src={'/images/Not-found-jobs.png'} />
      <div className="text-sm font-semibold mt-4">
        Hiện chưa có công việc nào theo tiêu chí bạn tìm
      </div>
      <div className="text-sm font-normal text-gray-800">
        Kiểm tra lại từ khóa hoặc thử bộ lọc khác
      </div>
      <div
        style={{ background: 'rgba(0, 0, 0, 0.05)' }}
        className="w-full h-[1px] mt-[50px] opacity-50"
      />

      <div className="flex items-center gap-2 mt-5 mb-7 w-full">
        <div className="min-w-[3px] h-[35px] bg-brand-300 rounded-t-[100px]" />
        <h3 className="text-base font-medium lg:text-lg lg:font-semibold">
          Dưới đây là một số gợi ý mà chúng tôi nghĩ có thể bạn quan tâm
        </h3>
      </div>

      <div className="flex flex-col items-center gap-y-4">
        <div className="flex-col gap-y-8 hidden md:flex">
          {recommendJobs.map(job => (
            <JobCardLargeSize key={job.id} job={job} />
          ))}
        </div>
        <div className="flex flex-col gap-y-8 md:hidden">
          {recommendJobs.map(job => (
            <JobCard key={job.id} job={job} />
          ))}
        </div>

        <button
          onClick={handleClearFilter}
          className="w-[200px] h-[38px] flex justify-center items-center text-brand-300 font-medium text-base px-[24px] py-[9px] rounded-[41px] border-[1px] border:solid border-brand-300"
        >
          Xem toàn bộ
        </button>
      </div>
    </div>
  );
};
